import { CommonModule } from '@angular/common';
import { Component, HostListener, inject, input, signal } from '@angular/core';
import { BreadcrumbItem, Breadcrumbs } from '@ntv360/component-pantry';
import { SubNavbarService } from './sub-navbar.service';

@Component({
    selector: 'app-sub-navbar',
    standalone: true,
    imports: [CommonModule, Breadcrumbs],
    templateUrl: './sub-navbar.component.html',
    styleUrl: './sub-navbar.component.scss',
})
export class SubNavbarComponent {
    /**
     * Service to dynamically append content on the sub-navbar component
     * since we can either display the time (default) or some content e.g button
     */
    protected subNavbarService = inject(SubNavbarService);

    /**
     * Signal to track if the page has been scrolled.
     */
    public scrolled = signal(false);

    /**
     * Listens for the window scroll event to update the 'scrolled' signal.
     */
    @HostListener('window:scroll', [])
    onWindowScroll() {
        const scrollOffset = window.scrollY;

        if (scrollOffset > 50) {
            this.scrolled.set(true);
        } else if (scrollOffset < 10) {
            this.scrolled.set(false);
        }
    }

    /**
     * The title of the current page or section.
     */
    public title = input<string>('');

    /**
     * The parent section or module for breadcrumb navigation.
     */
    public parent = input<string>('');

    /**
     * The url to navigate back to when click the breadcrumb
     */
    public url = input<string>('');

    /**
     * The current date used for display in the sub-navbar.
     */
    public today: Date = new Date();

    /**
     * Dynamically generates the list of breadcrumb items based on the current parent and title signals.
     * @returns An array of BreadcrumbItem objects for the ntv-breadcrumbs component.
     */
    public get breadcrumbItems(): BreadcrumbItem[] {
        const items: BreadcrumbItem[] = [];

        if (this.parent()) {
            items.push({
                label: this.parent(),
                url: this.url(),
            });
        }

        items.push({ label: this.title() });

        return items;
    }
}
